











import { Component, Emit, Prop, Mixins } from "vue-property-decorator";
import UtilMixin from "@/mixins/utilMixin";

@Component
export default class YesNoSelect extends Mixins(UtilMixin) {
  @Prop({ default: "有効無効" }) label!: string;

  @Prop() value!: number;

  private get Value() {
    return this.value;
  }

  private set Value(newValue: number) {
    this.input(newValue);
  }

  @Emit()
  private input(newValue: number) {
    return newValue;
  }
}
